import { render, staticRenderFns } from "./ContatosRapido.vue?vue&type=template&id=3231d418&scoped=true&"
import script from "./ContatosRapido.vue?vue&type=script&lang=js&"
export * from "./ContatosRapido.vue?vue&type=script&lang=js&"
import style0 from "./ContatosRapido.vue?vue&type=style&index=0&id=3231d418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3231d418",
  null
  
)

export default component.exports